/**
 * GradientBorderCard - Card with animated gradient border shimmer effect
 *
 * Features:
 * - Rotating gradient border on hover
 * - Blur glow effect behind the border
 * - Smooth opacity transitions
 */

"use client";

import { ReactNode } from "react";

interface GradientBorderCardProps {
  children: ReactNode;
  className?: string;
  /** Always show gradient (not just on hover) */
  alwaysActive?: boolean;
}

export default function GradientBorderCard({
  children,
  className = "",
  alwaysActive = false,
}: GradientBorderCardProps) {
  return (
    <div className={`relative group ${className}`}>
      {/* Blur glow layer */}
      <div
        className={`
          absolute -inset-[1px] rounded-2xl
          bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500
          blur-sm transition-opacity duration-500
          ${alwaysActive ? "opacity-50" : "opacity-0 group-hover:opacity-60"}
        `}
      />

      {/* Animated gradient border */}
      <div
        className={`
          absolute -inset-[1px] rounded-2xl
          bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500
          transition-opacity duration-300
          animate-shimmer-border
          ${alwaysActive ? "opacity-40" : "opacity-20 group-hover:opacity-50"}
        `}
        style={{ backgroundSize: "200% 100%" }}
      />

      {/* Card content */}
      <div className="relative bg-gray-900/95 backdrop-blur-xl rounded-2xl h-full">
        {children}
      </div>
    </div>
  );
}
